import { atom } from 'recoil'

export const openModalState = atom({
  key: 'openModalAtom',
  default: false,
})
